import React, { useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { AuthProvider } from "./components/AuthProvider";
import { WebSocketProvider } from "./contexts/WebSocketContext";
import { AppRoutes } from "./routes";
import { ErrorBoundary } from "./components/ErrorBoundary";
import { Toaster, toast } from "react-hot-toast";
// import PWAInstallPrompt from "./components/PWAInstallPrompt";
import "./App.css";
import "./styles/quartz.css";
import "./styles/brand-surfaces.css";
import config from "./config";
import { PerformanceCardProvider } from "./components/PerformanceCardContext";

// Separate config error component for cleaner code
const ConfigError = () => (
  <div className="config-error">
    <h1>Configuration Error</h1>
    <p>Google Client ID is not properly configured.</p>
    <p>Current value: {config.googleClientId}</p>
    <p>Please check your .env file and ensure it contains:</p>
    <pre>REACT_APP_GOOGLE_CLIENT_ID=your_actual_client_id</pre>
    <p>Then restart the application.</p>
  </div>
);

function App() {
  // Detect Composio OAuth permission denial and notify user
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const authError = params.get('auth_error');
    if (authError === 'permissions_required') {
      toast.error('Please approve all requested Gmail permissions to continue.');
      // Clean up the URL so the message does not reappear on refresh
      params.delete('auth_error');
      const newQuery = params.toString();
      const newUrl = window.location.pathname + (newQuery ? '?' + newQuery : '') + window.location.hash;
      window.history.replaceState({}, '', newUrl);
    }
  }, []);
  // Configuration validation
  if (
    !config.googleClientId ||
    config.googleClientId.includes("your_google_client_id")
  ) {
    return <ConfigError />;
  }

  const handleScriptLoadError = (err) => {
    console.error("Google OAuth script failed to load:", err);
    toast.error(
      "Failed to load authentication service. Please try again later."
    );
  };

  return (
    <ErrorBoundary>
      <BrowserRouter>
        <GoogleOAuthProvider
          clientId={config.googleClientId}
          onScriptLoadError={handleScriptLoadError}
        >
          <AuthProvider>
            {/* <AppProvider> */}
            <WebSocketProvider>
              <PerformanceCardProvider>
                <Toaster
                  position="top-right"
                  toastOptions={{
                    duration: 4000,
                    style: {
                      background: "#333",
                      color: "#fff",
                    },
                  }}
                />
                <AppRoutes />
                {/* <PWAInstallPrompt /> */}
              </PerformanceCardProvider>
            </WebSocketProvider>
            {/* </AppProvider> */}
          </AuthProvider>
        </GoogleOAuthProvider>
      </BrowserRouter>
    </ErrorBoundary>
  );
}

export default App;
